/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const undoDataSchema = z.object({ undone: z.literal(true) });

export const undoCollectionTriageClipResponseSchema = createApiResponseSchema(
  undoDataSchema,
) as z.ZodSchema<IAPI<{ undone: true }>>;

export type IUndoCollectionTriageClipResponse = IAPI<{ undone: true }>;
